(async () => {
  if (!customElements.get('delivery-text')) {
    class DeliveryText extends HTMLElement {
      constructor() {
        super();

        this.deliveryTomorrow = window.deliverySettings.deliveryTomorrow;
        this.delivery2BusinessDays = window.deliverySettings.delivery2BusinessDays;
        this.deliveryHolidays = window.deliverySettings.deliveryHolidays;

        this.checkDate();
      }

      checkDate() {
        if (this.deliveryTomorrow.length === 0 || this.delivery2BusinessDays.length === 0) {
          return;
        }

        let shopTimezoneOffset = 0;
        let hours = window.deliverySettings.timeHour;
        let minutes = window.deliverySettings.timeMinutes;
        const DateTime = luxon.DateTime;
        const customerTimezone = DateTime.local().o;
        const shopTimezone = DateTime.local().setZone(window.deliverySettings.shop_location).o;

        // check if the shop timezone is different from the client time zone. If so, update the hours so the correct cut-off is calculated. I.e. when the cut-off is set at 12pm shop time, the cut-off for the UK should be 11am and the cut-off for Moscow is 1pm. There are use cases where time zone is 7.5 hours difference, but that has not be calculated here.
        if (customerTimezone !== shopTimezone) {
          shopTimezoneOffset = ((customerTimezone - shopTimezone) / 60 * -1);
          hours = hours - shopTimezoneOffset;
        }

        const isHolidayCheck = inst => {
          let checkArray = this.deliveryHolidays.replace(' ', '').split(',');
          let checkDate = `${inst.day}-${inst.month}`;

          let match = false;
          checkArray.forEach((date) => {
            if (date == checkDate) {
              match = true;
            }
          });
          return match;
        };

        const cutOffTime = parseFloat(`${hours}.${minutes}`);
        const date = DateTime.local(); // get date from plugin
        const {hour, minute } = date;

        date.setupBusiness({
          businessDays: [1,2,3,4,5],
          holidayMatchers: [
            date.availableHolidayMatchers.isNewYearsDay,
            date.availableHolidayMatchers.isChristmasDay,
            isHolidayCheck,
          ],
        });

        const nextBusinessDay = date.plusBusiness();
        const tomorrow = date.plus({ days: 1 });
        const minutesTotal = minute / 100;
        const time = parseFloat(`${hour + minutesTotal}`);

        // Assume we can not deliver tomorrow
        let deliveryTomorrowCheck = false;

        // Get next possible delivery day
        if (time < cutOffTime) {
          // We meet the cutoff time, continue the check for holidays
          if (tomorrow.day == nextBusinessDay.day) {
            deliveryTomorrowCheck = true;
          }
        }

        // update the text
        this.textContent = deliveryTomorrowCheck ? this.deliveryTomorrow : this.delivery2BusinessDays;
      }
    }

    customElements.define('delivery-text', DeliveryText);
    window.DeliveryText = DeliveryText;
  }
})();
